/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import SubscriptionPlanCard from '../SubscriptionPlanCard';
import OrderWizard from '../../../../../commonComponents/modal/components/OrderWizard';
import RewardJourneyCard from '../../../../journey/overall/content/components/RewardJourneyCard';
import { useSanitize } from '../../../../../services/customHooks';
import RewardProp from '../../../../sessions/propTypes/rewardProp';

function OrderStep({ t, plans, selectedPlan, setSelectedPlan, step, error }) {
  const description = useSanitize(selectedPlan?.description);
  return (
    <>
      <div className="details">
        <OrderWizard
          activeStep={step === 'order' ? 1 : step === 'billing' ? 2 : 3}
        />
        <div className="sideBar-wrapper" />
      </div>
      <div className="subscription-plan-order-step">
        <div className="subscription-plan-modal-card-wrapper">
          {plans.map(plan => (
            <SubscriptionPlanCard
              t={t}
              plan={plan}
              title={plan.name}
              summary={plan.summary}
              userPrice={plan.userPrice}
              img={plan.imageSquare.url}
              setSelectedPlan={setSelectedPlan}
              userPromotionPrice={plan.userPromotionPrice}
              isChecked={selectedPlan && selectedPlan._id === plan._id}
              showCheckbox
              error={error}
            />
          ))}
        </div>
        <div className="subscription-plan-modal-order-details">
          {selectedPlan && (
            <>
              <SubscriptionPlanCard
                t={t}
                plan={selectedPlan}
                showCheckbox={false}
                title={selectedPlan.name}
                summary={selectedPlan.summary}
                userPrice={selectedPlan.userPrice}
                img={selectedPlan.imageHorizontal.url}
                userPromotionPrice={selectedPlan.userPromotionPrice}
              />
              <div
                dangerouslySetInnerHTML={{
                  __html: description,
                }}
                className="subscription-plan-modal-order-description"
                style={
                  selectedPlan?.reward?.userType ||
                  selectedPlan?.reward?.competenciesDomains?.length > 0
                    ? {}
                    : {
                        maxHeight: '360px',
                      }
                }
              />
              {selectedPlan?.reward?.userType && (
                <div className="plans-rewards">
                  <h3>{t('access_session.detail.reward')}</h3>
                  <RewardJourneyCard
                    type="userType"
                    reward={selectedPlan?.reward}
                  />
                </div>
              )}
              {selectedPlan?.reward?.competenciesDomains?.length > 0 && (
                <div className="plans-rewards">
                  <h3>{t('access_session.detail.reward')}</h3>
                  <RewardJourneyCard
                    type="competenciesDomains"
                    reward={selectedPlan?.reward}
                  />
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}
OrderStep.propTypes = {
  t: PropTypes.func.isRequired,
  plans: PropTypes.shape([]).isRequired,
  selectedPlan: PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
    summary: PropTypes.string,
    description: PropTypes.string,
    userPrice: PropTypes.shape({}),
    userPromotionPrice: PropTypes.shape({}),
    imageHorizontal: PropTypes.shape({ url: PropTypes.string }),
    reward: PropTypes.shape(RewardProp.propType),
  }).isRequired,
  setSelectedPlan: PropTypes.func.isRequired,
  step: PropTypes.string.isRequired,
  error: PropTypes.string,
};
OrderStep.defaultProps = {
  error: null,
};
export default OrderStep;
